<script>
    import { profile } from "../credentials.js";
    import { onMount, createEventDispatcher } from "svelte";
    import { userDocuments } from "../ui-store.js";
    import { PaperclipIcon } from "svelte-feather-icons";
    import moment from "moment";

    const dispatch = createEventDispatcher();

    export let mappedToVariable;
    export let disabled = false;
    export let locked = false;
    export let label = "";
    export let multiple = false;
    
    let selectedFile = "";
    
    let hasLocalFiles = false;
    let dropdownIsActive = false;
    let userloading = true;
    let fileInput;

    let openLocalFilesRepo = false;
    //for screenreaders
    let idTagDescription = 'description-'+ mappedToVariable;

    $:console.log("selectedFile", selectedFile);

    const handleFiles = (isLocal, file) => {
        dispatch("fileSelected", {
          isLocal: isLocal,
          value: file
        })
        console.log(fileInput);
    }

    const toggleOpenLocalRepo = () => { openLocalFilesRepo = !openLocalFilesRepo;}

    $:if (dropdownIsActive) {
      console.log('open');
      document.body.addEventListener('click', handleMenuClose)
    }

    const handleMenuClose = ()  => {
      dropdownIsActive = false;
      console.log('close');
      document.body.removeEventListener('click', handleMenuClose);
    }

    onMount(() => {
      hasLocalFiles = ($userDocuments && $userDocuments.length && $userDocuments.length > 0);
      let fileInput = document.getElementById(label);
      if (multiple) fileInput.setAttribute('multiple', '');
    })
</script>

<div class="dropdown is-up {dropdownIsActive ? ' is-active' : ''}" style="z-index: 3; ">
    <div class="dropdown-trigger">
      <!-- <div class="button" aria-haspopup="true" aria-controls="dropdown-menu2"> -->
        <span class="button" title="Επισύναψη αρχείου" aria-haspopup="true" aria-controls="dropdown-menu2" 
          on:click|stopPropagation={()=> { dropdownIsActive = !dropdownIsActive}}>
          <!-- <Fa icon={faPaperclip}  size="lg" aria-hidden="true"/> -->
          <div class="icon">
            <PaperclipIcon size="1.5x" />
          </div>
          <span class="file-label mx-2"> Επιλογή αρχείου... </span>
        </span>
    </div>
    <div class="dropdown-menu" id="dropdown-menu2" role="menu">
      <div class="dropdown-content">
        <div class="dropdown-item" on:click={toggleOpenLocalRepo}>
          <span class="is-size-6 mx-2">
           Από τα έγγραφά μου
          </span>
        </div>
        <hr class="dropdown-divider" />
        <div class="dropdown-item" on:click={()=>{fileInput.click();}}>
          <span class="is-size-6 mx-2">Από τον υπολογιστή μου</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Hidden file input -->
    <input
      aria-describedby={idTagDescription}
      readonly={disabled || locked} 
      id={label}
      type="file"
      bind:this={fileInput}
      bind:files={selectedFile}
      on:change={(e)=> {
        // console.log(e, selectedFile)
        handleFiles(false, selectedFile);
      }}
      accept={label.includes("ωτογ") || label.includes("ΩΤΟΓ")
        ? ".jpeg, .png, image/*;capture=camera"
        : ""}
      hidden
    />

    <!-- <input
      aria-describedby={idTagDescription}
      readonly={disabled || locked} 
      id={label}
      class="file-input {touched
        ? successful
          ? 'is-success'
          : 'is-danger'
        : ''}"
      type="file"
      bind:files={value}
      on:input={() => {
        touched = true;
        dispatch("validate");
      }}
      name="attachment"
      accept={label.includes("ωτογ") || label.includes("ΩΤΟΓ")
        ? ".jpeg, .png, image/*;capture=camera"
        : ".doc, .docx, .pdf, .jpeg, .png"}
    /> -->

    <!-- modal to choose from user documents -->
    {#if openLocalFilesRepo}
    <div class="modal is-active">
        <div class="modal-background"/>
        <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Επιλογή εγγράφου
            </p>
        </header>
        <section class="modal-card-body is-size-5-desktop is-size-6">
          <ul class="items">
            {#each $userDocuments as item, i}
            <li class="item p-3" 
            style="{(selectedFile && selectedFile.versionedFileId &&  selectedFile.versionedFileId === item.versionedFileId) ? 'border: 2px solid black; border-radius: 5px;': '' }"  
            on:click={()=> {selectedFile=item}}>
                <div class="columns">
                  {#if i>0}
                    <hr class="dropdown-divider"/>
                  {/if}
                    <div class="column">
                    {item.fileTitle}
                    </div>
                    <div class="column">{item.fileDescription || ''}</div>
                    <div class="column">
                      {moment(
                        item.uploadDate.split(" ")[0],
                            "yyyy-MM-DD"
                        ).format("dddd, Do MMMM YYYY")}
                        <br>
                        {moment(item.uploadDate.split(" ")[1], "HH:mm:ss").format(
                            "h:mm A"
                      )}
                    </div>
                </div>
            </li>
            {/each}
        </ul>
        </section>
        <footer class="modal-card-foot is-grouped level">
            <button
            class="button is-link has-background-link-dark is-size-5-desktop is-size-6"
            on:click={() => {
              toggleOpenLocalRepo();
              selectedFile = null;
            }}>
              Άκυρο
            </button>
            <button
            disabled={!selectedFile}
            class="button is-link has-background-link-dark is-size-5-desktop is-size-6"
            on:click={()=>{
              handleFiles(true, selectedFile);
              toggleOpenLocalRepo();
            }}>Επιλογή</button
            >
        </footer>
        </div>
        <button
        class="modal-close is-large"
        aria-label="close"
        on:click={toggleOpenLocalRepo}
        />
    </div>
{/if}

<style>
  .dropdown-menu {
    left: 10em !important;
  }

  .dropdown-item:hover, .item:hover{
    background-color: rgb(233, 233, 233);
    cursor: pointer;
  }
</style>